'use client';

import { ClerkProvider, useAuth } from '@clerk/clerk-react';
import { ConvexReactClient } from 'convex/react';
import { ConvexProviderWithClerk } from 'convex/react-clerk';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
const convex = new ConvexReactClient(process.env.NEXT_PUBLIC_CONVEX_URL!);
const CLERK_PKEY = process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY!;
const queryClient = new QueryClient();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function Providers(props: {
  children: any;
}) {
  return <ClerkProvider publishableKey={CLERK_PKEY}>
      <ConvexProviderWithClerk useAuth={useAuth} client={convex}>
        <QueryClientProvider client={queryClient}>{props.children}</QueryClientProvider>
      </ConvexProviderWithClerk>
    </ClerkProvider>;
}